import { combineReducers } from 'redux';
import { EModalType, clone } from '../../helpers';
import controlBlockConfigReducer from './control-block-config';
import controlConfigReducer from './control-config';
import actionConfigReducer from './action-config';
import decisionConfigReducer from './decision-config';
import outputDialogReducer from './outputs-dialog';
import summaryDialogReducer from './summary-dialog';
import submissionConfigReducer from './submission-config';
import sharedJourneyConfigReducer from './shared-journey-config';
import loopConfigReducer from './loop-config';
import saveAsReducer from './save-as';
import types from '../types';
import redirectConfigReducer from './redirect-config';

export interface IModalState {
	openModal: EModalType;
	warningMessages: string[];
	previousWarningMessages: string[];
	errorMessages: string[];
	errorMessageDismissed: boolean;
	overlayMessage: string;
	parentLoopId: string
};

export const initialState: IModalState = {
	openModal: EModalType.None,
	warningMessages: [],
	previousWarningMessages: [],
	errorMessages: [],
	errorMessageDismissed: false,
	overlayMessage: null,
	parentLoopId: null
};

const baseReducer = function(state:IModalState = initialState, action) {

	let stateClone:IModalState = clone(state);

	switch(action.type) {
		case types.TOGGLE_DIALOG:
			stateClone = toggleDialog(stateClone, action.openModal, action.parentLoopId);
			break;
		case types.SET_MODAL_ERROR_MESSAGES: 
			stateClone = setErrorMessages(stateClone, action.errorMessages);
			break;
		case types.SET_MODAL_WARNING_MESSAGES:
			stateClone = setWarningMessages(stateClone, action.warningMessages);
		case types.SET_ERROR_MESSAGE_DISMISSED:
			stateClone = setErrorMessageDismissed(stateClone, action.errorMessageDismissed);
			break;
		case types.SET_MODAL_OVERLAY_MESSAGE:
			stateClone = setModalOverlayMessage(stateClone, action.overlayMessage);
			break;
		default: 
			break;
	}

	return stateClone;

};

let toggleDialog = (state:IModalState, openModal:EModalType, parentLoopId: string):IModalState => {

	//if you are opening a new component or closing an existing one, then reset errorMessages, warningMessages, and previousWarningMessages
	if(state.openModal === 1 || state.openModal !== openModal) {
		state.errorMessages = [];
		state.warningMessages = [];
		state.previousWarningMessages = [];
	}

	state.openModal = openModal;
	state.overlayMessage = null;
	state.parentLoopId = parentLoopId;

	return state;

};

let setErrorMessages = (state: IModalState, errorMessages: string[]) => {

	state.errorMessages = errorMessages;
	state.errorMessageDismissed = false;
	state.overlayMessage = null;

	return state;

};

let setWarningMessages = (state: IModalState, warningMessages: string[]) => {
	state.errorMessageDismissed = false;
	state.overlayMessage = null;

	state.previousWarningMessages = state.previousWarningMessages.concat(warningMessages.filter(w => {
		return !state.previousWarningMessages.length || !state.previousWarningMessages.some(p => p === w);
	}));
	state.errorMessageDismissed = warningMessages.length ? true : state.errorMessageDismissed;
	state.warningMessages = warningMessages;

	return state;
};

let setErrorMessageDismissed = (state: IModalState, errorMessageDismissed: boolean) => {

	state.errorMessageDismissed = errorMessageDismissed;
	state.overlayMessage = null;

	return state;

};

let setModalOverlayMessage = (state: IModalState, overlayMessage: string) => {

	state.overlayMessage = overlayMessage;

	return state;

};

// Combine Reducers
let modalReducer = combineReducers({
	modal: baseReducer, 
	controlConfig: controlConfigReducer,
	saveAs: saveAsReducer,
	actionConfig: actionConfigReducer,
	decisionConfig: decisionConfigReducer,
	outputsDialogState: outputDialogReducer,
	summaryDialogState: summaryDialogReducer,
	controlBlockConfig: controlBlockConfigReducer,
	submissionConfig: submissionConfigReducer,
	sharedJourneyConfig: sharedJourneyConfigReducer,
	redirectConfig: redirectConfigReducer,
	loopConfigState: loopConfigReducer
});

export default modalReducer;


// WEBPACK FOOTER //
// ./source/ts/store/reducers/modal.ts